export function farloUiMobileSliderCast(carouselElement) {
    if (!carouselElement) return;

    const mediaQuery = window.matchMedia('(max-width: 980px)');
    let flkty = null;

    function cleanupMarkup() {
        // Remove leftover Flickity wrappers if any
        carouselElement.querySelectorAll('.flickity-viewport').forEach(vp => {
            const slider = vp.querySelector('.flickity-slider');
            if (slider && vp.parentNode === carouselElement) {
                const slides = Array.from(slider.children);
                vp.replaceWith(...slides);
            } else {
                vp.remove();
            }
        });
        carouselElement.classList.remove('flickity-enabled', 'is-draggable');
    }

    function initializeFlickity() {
        // Prevent double init
        if (carouselElement.classList.contains('flickity-enabled')) return;

        cleanupMarkup(); // clean DOM before initializing

        flkty = new Flickity(carouselElement, {
            cellAlign: 'center',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            draggable: true,
            adaptiveHeight: false,
        });

        // Refresh layout
        flkty.on('ready', () => flkty.resize());
        setTimeout(() => flkty.resize(), 100);
    }

    function destroyFlickity() {
        if (flkty) {
            flkty.destroy();
            flkty = null;
        }
        cleanupMarkup();
    }

    function handleResize() {
        if (mediaQuery.matches) {
            initializeFlickity();
        } else {
            destroyFlickity();
        }
    }

    imagesLoaded(carouselElement, handleResize);

    window.addEventListener('resize', debounce(handleResize, 150));
}

function debounce(fn, delay) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), delay);
    };
}
